<template>
    <div>
        <!-- Modal Pausar Atendimento -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Pausar Atendimento</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="h3">Confirma pausar o atendimento do paciente?</div>

                        <template v-if="tem_timer">
                            <div class="text-center my-5">
                                <i class="fa-solid fa-pause fa-4x fa-fw" v-if="!define_timer"></i>
                                <i class="fa-solid fa-stopwatch fa-4x fa-fw" v-else></i>
                            </div>

                            <az-input
                                type="checkbox-group"
                                label="Definir Timer (Contagem Regressiva)"
                                v-model="define_timer" />

                            <az-input
                                icon="fa-solid fa-stopwatch fa-fw"
                                type="number"
                                step="15"
                                v-if="define_timer"
                                v-model="tempo">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2">minutos</span>
                                    </div>
                                </template>
                            </az-input> 
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="confirmar()">Pausar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            tem_timer: false, 
            define_timer: false,
            tempo: 0,
        }
    },

    components: { 
        AzInput, 
    }, 

    props: ['modal_base'],

    computed: {
        modal_name: function() {
            return this.modal_base + '-pausar-modal'
        }
    },

    methods: { 
        pausar(callback, tem_timer = false, tempo = 0) { 
            this.callback = callback;
            this.tempo = tempo; 
            this.tem_timer = tem_timer;
            this.define_timer = tempo > 0 ? true : false;

            $('#' + this.modal_name).modal('show');
        }, 

        confirmar() { 
            if ( this.tem_timer && this.define_timer && !this.tempo ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Timer', 
                    detail: 'Informe o tempo do timer para pausar o atendimento.'
                })
                return;
            }

            this.callback(this.tem_timer && this.define_timer ? this.tempo : null);
            this.fechar();
        },

        fechar() { 
            $('#' + this.modal_name).modal('hide');
        }
    }
}
</script>
